import { createAsyncThunk } from '@reduxjs/toolkit';
import httpService from './httpService';
export const getLanguagesList: any = createAsyncThunk<any>(
	'getLanguagesList',
	async (data: any) => {
		const response = await httpService.get('common/language', {
			params: data
		});
		return response.data;
	}
);
export const getCountryList: any = createAsyncThunk<any>(
	'getCountryList',
	async (data: any) => {
		const response = await httpService.get('common/get-countries', {
			params: data
		});
		return response.data;
	}
);
export const addCountry: any = createAsyncThunk<any>(
	'addCountry',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.post('common/country', data);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const editCountry: any = createAsyncThunk<any>(
	'editCountry',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.put(`common/country`, data);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const deleteCountry: any = createAsyncThunk<any>(
	'deleteCountry',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.delete(`common/country`, {
				params: data
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
export const getRegionList: any = createAsyncThunk<any>(
	'getRegionList',
	async (data: any) => {
		const response = await httpService.get('common/region', {
			params: data
		});
		return response.data;
	}
);
export const addRegion: any = createAsyncThunk<any>(
	'addRegion',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.post('common/region', data);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error.response?.data);
		}
	}
);
export const editRegion: any = createAsyncThunk<any>(
	'editRegion',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.put(`/common/region`, data);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const deleteRegion: any = createAsyncThunk<any>(
	'deleteRegion',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.delete(`common/region`, {
				params: data
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
export const getCityList: any = createAsyncThunk<any>(
	'getCityList',
	async (data: any) => {
		const response = await httpService.get('common/city', {
			params: data
		});
		return response.data;
	}
);
export const getCityListWithoutPaginaiton: any = createAsyncThunk<any>(
	'getCityListWithoutPaginaiton',
	async (data: any) => {
		const response = await httpService.get('common/city', {
			params: data
		});
		return response.data;
	}
);
export const addCity: any = createAsyncThunk<any>(
	'addCity',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.post('common/city', data);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error.response?.data);
		}
	}
);
export const editCity: any = createAsyncThunk<any>(
	'editCity',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.put(`common/city`, data);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const deleteCity: any = createAsyncThunk<any>(
	'deleteCity',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.delete(`common/cities-status`, {
				data: data
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
export const regionStatus: any = createAsyncThunk<any>(
	'regionStatus',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.put(
				`common/region-status`,
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
export const countryStatus: any = createAsyncThunk<any>(
	'countryStatus',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.put(
				`common/country-status`,
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
export const cityStatus: any = createAsyncThunk<any>(
	'cityStatus',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.put(
				`common/cities-status`,
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
